export const CUSTOM_ITEM_DIMENSIONS_CONTROL_LONGER_SIDE = 30;
export const CUSTOM_ITEM_DIMENSIONS_CONTROL_SHORTER_SIDE = 8;
export const CUSTOM_LINE_ITEM_DIMENSIONS_CONTROL = 15;
export const CUSTOM_ITEM_SCALING_CONTROL_SIDE = 14;
export const CUSTOM_ITEM_CONTROL_WITH_ICON_SIDE = 28;
export const CUSTOM_ITEM_CONTROL_BORDER = 1;

export enum CustomControlCursor {
  CURSOR_EW_RESIZE = 'ew-resize',
  CURSOR_NS_RESIZE = 'ns-resize',
  CURSOR_NWSE_RESIZE = 'nwse-resize',
  CURSOR_NESW_RESIZE = 'nesw-resize',
  CURSOR_POINTER = 'pointer',
  CURSOR_MOVE = 'move',
  CURSOR_CROSSHAIR = 'crosshair',
}

export interface FabricObjectPositionOrDimensionKeys {
  height: number;
  scaledHeight: number;
  width: number;
  scaledWidth: number;
  scaleX: number;
  scaleY: number;
  left: number;
  top: number;
  posterScale: number;
  angle: number;
  strokeWidth: number;
  borderScaleFactor: number;
}

export enum SelectionType {
  SINGLE_ITEM_SELECTION = 'single-item-selection',
  HOVERED_ITEM = 'hovered-item',
  MULTI_SELECTION = 'multi-selection',
  MARQUEE_PREVIEW = 'marquee-preview',
}
